import _get from 'lodash/get';

import { HttpRoutes } from 'utils/constant';

import { format, removeSpecialCharacter } from '../utils';

import Service from './service';

// TODO Move to constants
const getCompaniesByIds = '/api/getCompaniesByIds';
const getCompanyDataById = '/api/getCompanyDataById';
// TODO: Move to constants

const CommonService = {
  normalizedData(payload) {
    let url = HttpRoutes.getNormalizedData;
    if (payload.major) {
      url = HttpRoutes.getNormalizedMajorData;
    }
    return Service.post(url, payload)
      .then((response) => response)
      .catch((error) => error);
  },

  getCompanyInfoByIds(companyIds) {
    const payload = {
      companyIds,
    };
    return Service.post(getCompaniesByIds, payload)
      .then((response) => {
        if (response.data && response.data.length > 0) {
          return response.data[0];
        }
        return Promise.reject();
      })
      .catch((error) => Promise.reject(error));
  },

  getCititesByState(data) {
    return Service.get(format(HttpRoutes.getCititesByState, data))
      .then((response) => {
        return Promise.resolve(response.data);
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  },

  analyticsToLog(data) {
    const payload = {
      data,
    };
    return Service.post(HttpRoutes.analyticsToLog, payload)
      .then((response) => {
        return Promise.resolve(response.data);
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  },

  getCompanyDataById(companyId) {
    const payload = {
      companyId,
    };
    return Service.post(getCompanyDataById, payload)
      .then((response) => {
        return Promise.resolve(response.data);
      })
      .catch((error) => Promise.reject(error));
  },

  getCompanyDemographicsDataById(data) {
    return Service.get(format(HttpRoutes.getCompanyDemographicsDataById, data))
      .then((response) => {
        return Promise.resolve(response.data);
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  },

  fetchSalariesByLocation(data) {
    return Service.post(HttpRoutes.salaryDataByTitleSalaryPagebyLocation, data)
      .then((response) => {
        return Promise.resolve(response.data);
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  },

  fetchSalariesByMajor(data) {
    return Service.post(HttpRoutes.salaryByLocationMajorSalaryPage, data)
      .then((response) => Promise.resolve(response.data))
      .catch((error) => Promise.reject(error));
  },

  fetchSalariesByMajorAndCompany(data) {
    return Service.post(HttpRoutes.getSalariesByMajorAndCompany, data)
      .then((response) => Promise.resolve(response.data))
      .catch((error) => Promise.reject(error));
  },

  fetchSalariesByTitleAndCompany(data) {
    return Service.post(HttpRoutes.salaryDataByTitleSalaryPagebyCompany, data)
      .then((response) => {
        return Promise.resolve(response.data);
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  },

  fetchSalariesByCompany(data) {
    return Service.post(HttpRoutes.getSalaryDataByCompany, data)
      .then((response) => {
        return Promise.resolve(response.data);
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  },

  fetchSalariesByJobTitle(data, sliceParams = true) {
    data.param = sliceParams ? data.param.slice(0, 10) : data.param;
    return Service.post(HttpRoutes.salaryDataByTitleSalaryPageByJobTitle, data)
      .then((response) => {
        return Promise.resolve(response.data);
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  },

  fetchCompanySalariesByCompany(data) {
    data.locations = data.locations.slice(0, 3);
    return Service.post(HttpRoutes.fetchCompanySalariesByCompany, data)
      .then((response) => {
        return Promise.resolve(response.data);
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  },

  fetchCompanyPoliticalDonators(data) {
    return Service.get(format(HttpRoutes.getCompanyDonators, data))
      .then((response) => {
        return Promise.resolve(response.data);
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  },

  fetchJobTitleRecentSalaries(data) {
    return Service.post(HttpRoutes.fetchJobTitleRecentSalaries, data)
      .then((response) => {
        return Promise.resolve(response.data);
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  },

  fetchSalaryHistoryDataByLocation(data) {
    return Service.post(HttpRoutes.getSalaryHistoryChartData, data)
      .then((response) => {
        return Promise.resolve(response.data);
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  },

  fetchPreparedSalaryDataByLocation(data) {
    return Service.get(format(HttpRoutes.getPreparedSalaryDataByLocation, data))
      .then((response) => {
        return Promise.resolve(response.data);
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  },

  fetchSalaryDataByTitleAndLocation(data) {
    return Service.get(format(HttpRoutes.salaryDataByTitleAndLocation, data))
      .then((response) => {
        return Promise.resolve(response.data);
      })
      .catch(() => {
        return Promise.resolve({ topSalaryData: [] });
      });
  },

  // Location is optional.
  fetchSalaryChartDataByTitleAndLocation(data) {
    return Service.post(HttpRoutes.getSalaryChartDataByTitleAndLocation, data)
      .then((response) => {
        if (!Object.keys(response.data).length) {
          throw new Error('API returned empty response.');
        }
        return Promise.resolve(response.data);
      })
      .catch(() => {
        return Promise.resolve(null);
      });
  },

  fetchNextPrevReviewForCompany(data) {
    return Service.post(HttpRoutes.getNextPrevReviewForCompany, data)
      .then((response) => {
        return Promise.resolve(response.data);
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  },

  moderateReview(data) {
    return Service.post(HttpRoutes.moderateReview, data)
      .then((response) => {
        return Promise.resolve(response.data);
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  },

  fetchNextPrevReviewForJobTitle(data) {
    return Service.post(HttpRoutes.getNextPrevReviewForJobTitle, data)
      .then((response) => {
        return Promise.resolve(response.data);
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  },

  getProfileSummary(data) {
    return Service.get(format(HttpRoutes.getProfileSummary, { title: data }))
      .then((response) => {
        return Promise.resolve(response.data);
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  },

  fetchTopCollegesForJobTitle(data) {
    return Service.post(HttpRoutes.getTopCollegesForTitle, data)
      .then((response) => {
        return Promise.resolve(response.data);
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  },
  fetchTopCollegesForMajor(data) {
    return Service.post(HttpRoutes.getTopCollegesForMajor, data)
      .then((response) => {
        return Promise.resolve(response.data);
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  },
  fetchDiversityPieChartData(data) {
    return Service.post(HttpRoutes.getDiversityPieChartData, data)
      .then((response) => Promise.resolve(response.data))
      .catch((error) => Promise.reject(error));
  },

  fetchMostCommonDegreesPieChartData(data) {
    return Service.post(HttpRoutes.getMostCommonDegreesPieChartData, data)
      .then((response) => Promise.resolve(response.data))
      .catch((error) => Promise.reject(error));
  },

  fetchGenderRatioBarChartData(data) {
    return Service.post(HttpRoutes.getGenderRatioBarChartData, data)
      .then((response) => Promise.resolve(response.data))
      .catch((error) => Promise.reject(error));
  },

  fetchTitleAgeBreakdownData(data) {
    return Service.post(HttpRoutes.getTitleAgeBreakdownData, data)
      .then((response) => Promise.resolve(response.data))
      .catch((error) => Promise.reject(error));
  },

  fetchTitleDurationsData(data) {
    return Service.post(HttpRoutes.getTitleDurationData, data)
      .then((response) => Promise.resolve(response.data))
      .catch((error) => Promise.reject(error));
  },

  fetchTitleCompanySizesData(data) {
    return Service.post(HttpRoutes.getTitleCompanySizesData, data)
      .then((response) => Promise.resolve(response.data))
      .catch((error) => Promise.reject(error));
  },

  fetchTitleCompanyTypesData(data) {
    return Service.post(HttpRoutes.getTitleCompanyTypesData, data)
      .then((response) => Promise.resolve(response.data))
      .catch((error) => Promise.reject(error));
  },

  fetchTitleIndustriesData(data) {
    return Service.post(HttpRoutes.getTitleIndustriesData, data)
      .then((response) => Promise.resolve(response.data))
      .catch((error) => Promise.reject(error));
  },

  fetchLgbtRatioData(data) {
    return Service.post(HttpRoutes.getLgbtRatioData, data)
      .then((response) => Promise.resolve(response.data))
      .catch((error) => Promise.reject(error));
  },

  fetchRecentSalaries(data) {
    return Service.post(HttpRoutes.fetchJobTitleRecentSalaries, data)
      .then((response) => Promise.resolve(_get(response, 'data.salaryData', [])))
      .catch((error) => Promise.reject(error));
  },

  fetchDemographicAdjustmentData(data) {
    return Service.post(HttpRoutes.getDemographicAdjustmentData, data)
      .then((response) => Promise.resolve(_get(response, 'data', {})))
      .catch((error) => Promise.reject(error));
  },

  fetchCompanyDemographicAdjustmentData(data) {
    return Service.post(HttpRoutes.getCompanyDemographicAdjustmentData, data)
      .then((response) => Promise.resolve(_get(response, 'data', {})))
      .catch((error) => Promise.reject(error));
  },

  getCompanyEmployeeProfileSummaryForGenders(companyIds) {
    const payload = {
      companyIds: companyIds,
    };
    return Service.post(HttpRoutes.getCompanyEmployeeProfileSummaryForGenders, payload)
      .then((response) => {
        if (response.data && response.data.length) {
          return Promise.resolve(response.data);
        } else {
          return Promise.resolve([]);
        }
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  },

  getEmployeeProfileSummaryForEthnicities(companyIds) {
    const payload = {
      companyIds: companyIds,
    };
    return Service.post(HttpRoutes.getEmployeeProfileSummaryForEthnicities, payload)
      .then((response) => {
        if (response.data && response.data.length) {
          return Promise.resolve(response.data);
        } else {
          return Promise.reject();
        }
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  },

  getCompanyComparisonData(companyIds) {
    const payload = {
      companyIds: companyIds,
    };
    return Service.post(HttpRoutes.getCompanyComparisonData, payload)
      .then((response) => {
        if (response.data && response.data.length) {
          return Promise.resolve(response.data);
        } else {
          return Promise.reject();
        }
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  },

  /**
   * Fetch pageLevelData from career compare page with a job title.
   * @param {string} title
   * @returns {object} - pageLevelData for the give jobTitle.
   */
  getCareerVersusData(title) {
    return Service.get(format(HttpRoutes.getCareerVersusData, { title }))
      .then((response) => {
        if (response.data && response.data.length) {
          return Promise.resolve(response?.data?.[0]);
        } else {
          return Promise.reject();
        }
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  },

  getCollegeExtendedData: (data) => {
    return Service.post(HttpRoutes.getCollegeExtendedData, data)
      .then((res) => Promise.resolve(res.data))
      .catch((error) => Promise.reject(error));
  },

  /**
   * Get soft skills by titles
   * @param {{ titles: string[]; }} data
   * @returns
   */
  getSoftSkillsByTitles: (data) => {
    return Service.post(HttpRoutes.getSoftSkillsByTitles, data)
      .then((res) => Promise.resolve(res.data))
      .catch((error) => Promise.reject(error));
  },

  /**
   * Get soft skills by titles
   * @param {string} answers
   * @returns
   */
  submitHollandAnswers: (answers) => {
    return Service.post(HttpRoutes.submitHollandAnswers, { answers })
      .then((res) => Promise.resolve(res.data))
      .catch((error) => Promise.reject(error));
  },

  /**
   * Get soft skills by titles
   * @param {string} interestCode
   * @returns
   */
  getJobTitlesByInterestCode: (interestCode) => {
    return Service.post(HttpRoutes.getJobTitlesByInterestCode, { interestCode })
      .then((res) => Promise.resolve(res.data))
      .catch((error) => Promise.reject(error));
  },

  getTitleSalaryOnlyStatesMapFileUrl: (title = '') => {
    const encodedTitle = removeSpecialCharacter(title);
    return `${format(HttpRoutes.getSalaryOnlyStatesMapForTitle, { encodedTitle })}.svgz`;
  },

  async getTitlesIndexes(titles) {
    const payload = {
      titles,
    };

    try {
      const { data } = await Service.post(HttpRoutes.getTitlesIndexes, payload);

      return data;
    } catch (err) {
      return err;
    }
  },

  async generateJobDescription(jobTitle) {
    const url = `${HttpRoutes.generateJobDescription}?jobTitle=${jobTitle}`;
    return Service.get(url)
      .then((res) => Promise.resolve(res.data))
      .catch((error) => Promise.reject(error));
  },

  /**
   * Fetches a resume file from the /resume/download/ route and returns it blobified.
   * @param {string} resumeLink
   * @param {string} candidateId
   */
  getResumeBlob(resumeLink, candidateId) {
    const route = `/resume/download/?path=${resumeLink}&userId=${candidateId}&respond=true`;
    return Service.get(route, { responseType: 'blob', timeout: 5000 })
      .then((resp) => Promise.resolve(resp.data))
      .catch(async (err) => {
        if (err?.response?.data instanceof Blob) {
          const text = await err.response.data.text()
          err.response.data.error = text && JSON.parse(text).error;
        }
        return Promise.reject(err);
      });
  },

  getBestCompanyListMatchedCities(data) {
    return Service.post(HttpRoutes.getBestCompanyListMatchedCities, data)
      .then((res) => Promise.resolve(res.data))
      .catch((error) => Promise.reject(error));
  },

  getAggregateCategoryRatings(data) {
    return Service.post(HttpRoutes.getAggregateCategoryRatings, data)
      .then((res) => Promise.resolve(res.data))
      .catch((error) => Promise.reject(error));
  },

  getJobsCount(jobTitle) {
    return Service.get(`${HttpRoutes.getJobsCount}?title=${jobTitle}`)
      .then((res) => Promise.resolve(res.data))
      .catch((error) => Promise.reject(error));
  }
};

export default CommonService;
